import React from "react";
import { Breadcrumb } from "../../../../components/Breadcrumb";

export const Contact = () => {
    document.title = "Operator ilə əlaqə";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Göstəricilər", value: "/dashboard" },
        { name: "Texniki dəstək", value: "/dashboard/support" },
        { name: "Operator ilə əlaqə", value: "/dashboard/support/contact", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Operator ilə əlaqə</h2>
                    <p>
                        Əməliyyatların icra olunması zamanı kömək xarakterli təlimatlar əldə etmək üçün nəzərdə tutulub.
                        <ol>
                            <li>? düyməsini sıxın və açılan pəncərədə Təlimat düyməsinə klik edin</li>
                            <li>Tərtibatçı ilə əlaqə düyməsi ilə birbaşa texniki dəstək şöbəsinə WhatsApp vasitəsilə yaza bilərsiniz</li>
                        </ol>
                    </p>
                    <img src="/images/dashboard/support/contact.gif" alt="Operator ilə əlaqə" />
                </article>
            </div>
        </div>
    );
};
